export default {
  "menu.dashboard": "仪表盘",
  "menu.form": "表单页",
  "menu.dashboard.workplace": "工作台",
  "navbar.logout": "退出登录",
  "settings.title": "页面配置",
  "settings.themeColor": "主题色",
  "settings.content": "内容区域",
  "settings.navbar": "导航栏",
  "settings.menuWidth": "菜单宽度 (px)",
  "settings.navbar.theme.toLight": "点击切换为亮色模式",
  "settings.navbar.theme.toDark": "点击切换为暗黑模式",
  "settings.menu": "菜单栏",
  "settings.footer": "底部",
  "settings.popUpMenu": "弹出式子菜单",
  "settings.popUpMenuType": "弹出菜单类型",
  "settings.popUpMenuType.button": "分组按钮",
  "settings.popUpMenuType.menu": "分组菜单",
  "settings.tableHeightControl": "表格高度控制",
  "settings.formShowTab": "表单Tab模式",
  "settings.tableSize": "表格尺寸",
  "settings.otherSettings": "其他设置",
  "settings.colorWeek": "色弱模式",
  "settings.copySettings": "复制配置",
  "settings.copySettings.message": "复制成功，请粘贴到 public/settings.json 文件中",
  "settings.close": "关闭",
  "settings.color.tooltip": "根据主题颜色生成的 10 个梯度色（将配置复制到项目中，主题色才能对亮色 / 暗黑模式同时生效）",
  "title": "得尔美卓越运营管理系统",
  "main": "OpXMOM",
  "maindata": "基础数据",
  "marketing": "营销管理",
  "boms": "BOM信息",
  "flow": "流程相关",
  "report": "报表",
  "theme": "主题",
  "language": "语言",
  "logout": "退出登录",
  "version": "版本号",
  "feedback": "服务反馈",
  "refresh": "刷新",
  "b_refresh": "刷新",
  "b_closeOther": "关闭其他",
  "b_close_all": "关闭全部",
  "b_close_current": "关闭当前",
  "b_Fill_out_the_action_plan": "填写行动计划",
  "b_query": "查询",
  "b_complexQuery": "高级",
  "b_add": "添加",
  "b_del": "删除",
  "b_output": "导出",
  "b_inport": "导入",
  "b_edit": "修改",
  "b_show": "查看",
  "b_confirm": "确认",
  "b_cancel": "取消",
  "b_return": "返回",
  "b_save": "保存",
  "b_enable": "启用",
  "b_disable": "禁用",
  "b_addChild": "添加下级",
  "t_menu": "功能菜单",
  "t_page_is_loading": "页面加载中",
  "t_unauth_page": "未授权的页面",
  "t_remind": "提示信息",
  "t_form_change_content": "表单已经被修改,是否仍然要退出?",
  "t_page": "页",
  "t_hasDelete": "数据已删除",
  "t_deleteFail": "删除失败",
  "t_hasEnable": "数据已启用",
  "t_enableFail": "启用失败",
  "t_hasDisabled": "数据已禁用",
  "t_disabledFail": "禁用失败",
  "t_successToSet": "设置成功",
  "t_confirmDeleteData": "确认删除数据？",
  "t_titleDeleteData": "删除数据",
  "t_keyword": "关键字",
  "t_pleaseInput": "请输入",
  "t_pleaseSelect": "请选择",
  "t_failToAdd": "添加失败",
  "t_successToAdd": "添加成功",
  "t_failToUpdate": "更新失败",
  "t_successToUpdate": "更新成功",
  "t_formError": "表单错误",
  "t_errorToReadData": "数据读取失败",
  "t_operate": "操作",
  "t_search": "查找",
  "t_titleAddData": "添加数据",
  "t_titleEditData": "编辑数据",
  "t_titleAdd": "添加",
  "t_titleEdit": "编辑",
  "t_titleShowData": "查看数据",
  "t_yes": "是",
  "t_no": "否",
  "t_grant_auth": "授权",
  "t_plsSelectData": "请选择数据",
  "t_searchUser": "查找用户",
  "t_required": "必填",
  "t_ruleError": "校验失败",
  "t_ruleEmail": "邮箱格式错误",
  "t_ruleMobile": "手机号格式错误",
  "t_ruleId": "身份证格式错误",
  "t_ruleUrl": "url格式出错误",
  "t_ruleIpv4": "ip地址格式错误",
  "t_ruleDate": "日期格式错误",
  "t_ruleDateTime": "日期时间格式错误",
  "t_ruleInt": "整数格式错误",
  "t_ruleFloat": "小数格式错误",
  "t_rulePostalNo": "邮政编号格式错误",
  "t_ruleQQ": "QQ号格式错误",
  "t_ruleWechat": "微信号格式错误",
  "t_ruleCarNo": "车牌号格式错误",
  "t_ruleLetter": "字符串中只能包含字母",
  "t_ruleCN": "字符串中必须包含中文",
  "t_rulePassword": "密码长度必须大于等于6位",
  "t_download": "下载",
  "t_downloadFail": "下载失败",
  "t_uploadFileSuccess": "上传文件成功",
  "t_uploadFileFail": "上传文件失败",
  "t_errParentNotItself": "父级分类不能设置成本身",
  "t_failToGetData": "获取数据失败",
  "t_formInitUrlDataError": "抱歉，你访问的当前页面数据出现异常，关闭页面。",
  "login.msg.userOrPwdError": "用户名或密码错误",
  "login.msg.technicalSupport": "龙人亦进",
  "common.no": "序号",
  "common.status": "状态",
  "common.lastModifierId": "更新人",
  "common.lastModificationTime": "更新时间",
  "common.remark": "备注",
  "common.success": "成功",
  "common.fail": "失败",
  "common.sort":"排序",
  "attachments.formTitle": "附件管理",
  "attachments.type": "附件类型",
  "attachments.download": "附件下载",
  "attachments.desc": "描述",
  "attachments.isDefault": "是否默认",
  "attachments.format": "格式",
  "attachments.size": "大小(kb)",
  "attachments.downloadNum": "下载次数",
  "attachments.uploader": "上传者",
  "attachments.uploaded": "上传时间",
  "attachments.upload": "上传附件",
  'user.password': '密码',
  'user.confirmPassword': '再输一次密码',
  'user.twicePwdNotSame': '两次输入的密码不一致',
  'user.currentPassword': '旧密码',
  'user.newPassword': '新密码',
  'user.editPassword': '修改密码',
  "workshop.workshop": "所在部门",
  "mold.formTitle": "模具信息",
  "team.empList": "员工清单",
  "plants.reception_time": "接收时间",
  "plants.planQty": "计划数量",
  "plants.Handling_situation": "处理情况",
  "plants.processedBy": "处理人",
  "plants.isTheActionEffective": "行动是否有效",
  "plantsDelayHandling.processStatus": "交付状态",
  "plantsDelayHandling.pmcNo": "工单单号",
  "plantsDelayHandling.planQty": "计划数量",
  "plantsDelayHandling.planEndDate": "计划结束",
  "plantsDelayHandling.actualFinishQty": "累计完成数量",
  "plantsEfficiencyDefectiveHandling.effiRate": "效率",
  "plantsEfficiencyDefectiveHandling.pmcNo": "工单单号",
  "plantsEfficiencyDefectiveHandling.nodeTitle": "工序名称",
  "plantsEfficiencyDefectiveHandling.materialCode": "物料编码",
  "plantsEfficiencyDefectiveHandling.workerName": "员工姓名",
  "plantsInspection.pmcNo": "工单单号",
  "plantsInspection.workerName": "员工姓名",
  "plantsInspection.currentVerificationQuantity": "当前校验数量",
  "productionScheduling.workOrderStatus": "工单状态",
  "productionScheduling.deliveryStatus": "交付状态",
  "productionScheduling.workOrderNumber": "工单单号",
  "productionScheduling.materialCode": "物料编码",
  "productionScheduling.materialName": "物料名称",
  "pickerDate.placeholder": "请选择日期",
  "pickerMonth.placeholder": "请选择月份",
  "pickerYear.placeholder": "请选择年份",
  "pickerWeek.placeholder": "请选择周",
  "pickerQuarter.placeholder": "请选择季度",
  "pickerRangeStart.placeholder": "开始日期",
  "pickerRangeEnd.placeholder": "结束日期",
  "pickerTime.placeholder": "请选择时间",
  
  "process.formTitle": "工序信息",
  "process.deptKey": "所在部门",
  "process.code": "工序代码",
  "process.name": "工序名称",
  "process.isOutput": "是否产出工序",
  "process.description": "工序描述",
  "process.graph": "图形",
  "process.nodeTypeKey": "工序类型",
}
